<template>
  <div>
    <Header/>
    <div class="container">
      <!-- Filter -->
      <div class="col-12 search-box mb-5 clearfix" id="search">
        <div class="row">
          <div class="col-12">
            <label class="title">FILTER:</label>
          </div>
        </div>

        <div class="row">
          <div class="col-12 d-flex mr-2 mb-2">
            <input
              v-model="searchForm.contentId"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Content Id"
            />
            <input
              v-model="searchForm.account"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Account"
            />
            <input
              v-model="searchForm.action"
              class="form-control mr-2 mb-2"
              type="text"
              placeholder="Action"
            />
            <date-picker
              class="date-control mr-2 mb-2"
              placeholder="Start Time"
              type="date"
              v-model="searchForm.startDate"
              :disabled-date="disabledStartTime"
            ></date-picker>
            <date-picker
              class="date-control mr-2 mb-2"
              placeholder="End Time"
              type="date"
              v-model="searchForm.endDate"
              :disabled-date="disabledEndTime"
            ></date-picker>

            <div>
              <button class="btn btn_control mr-1 mb-2" v-on:click="() => {this.pageNo = 1; search()}">Apply</button>
              <button class="btn btn_control mr-1 mb-2" v-on:click="clearFilterSearch(true)">Clear</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="table-box list-grid mb-5" v-if="loading">
        <div class="text-center">
          <div class="spinner-border text-darkg" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div v-else class="table-box list-grid mb-5">
        <div class="row ml-0 mr-0">
          <div class="title col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <h6>ACTIVITY MANAGER</h6>
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 d-flex justify-content-end pl-2">
            <button type="button" class="btn btn-info" @click="exportData()">
              <span class="glyphicon glyphicon-export"></span> Export
            </button>
          </div>
        </div>

        <div class="content-table">
          <table class="table table-hover table-md" style="overflow: inherit; table-layout: fixed;">
            <thead>
            <tr style=" text-align:top;">
              <th style="width: 150px">ACCOUNT</th>
              <th style="width: 150px">ACTION</th>
              <th style="width: 150px">VALUE</th>
              <th style="width: 80px">OBJECT TYPE</th>
              <th style="width: 100px">TIME</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in rows" v-bind:key="item.id">
              <td>{{item.account}}</td>
              <td>{{item.action }}</td>
              <td v-if="item.objectId">{{item.objectId}}</td>
              <td v-else>{{item.value | jsonView(['sort', 'reqType', 'pageSize']) }}</td>
              <td>{{item.objectType}}</td>
              <td>{{new Date(item.time) | moment('YYYY-MM-DD HH:mm:ss')}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-4 pagination">
          <div class="col-5">
          <span
            style="color: #3199bb;font-size:12px;font-weight:700; "
          >{{getFirstItemIndex()}}-{{getLastItemIndex()}} of {{totalData}}</span>
          </div>
          <div class="col-7" v-show="totalData > pageSize">
            <b-pagination
              :total-rows="totalData"
              v-model="pageNo"
              :per-page="pageSize"
              style="float: right"
            />
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Header from '@/components/common/Header'

import JsonViewFilter from '@/filter/JsonViewFilter'

import Footer from '@/components/common/Footer'
import {BPagination} from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'

import {searchStatistic} from '../../common/statistic'

export default {
  name: 'ActivityManager',
  components: {
    Header,
    Footer,
    'b-pagination': BPagination,
    DatePicker,
    JsonViewFilter
  },
  data () {
    return {
      searchForm: {
        contentId: '',
        account: '',
        action: '',
        startDate: null,
        endDate: null
      },
      loading: false,
      pageNo: 1,
      pageSize: 10,
      totalData: 0,
      rows: []
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    getFirstItemIndex () {
      if (this.totalData == 0) {
        return 0
      }
      return this.pageSize * (this.pageNo - 1) + 1
    },
    getLastItemIndex () {
      return this.pageSize * this.pageNo <= this.totalData
        ? this.pageSize * this.pageNo
        : this.totalData
    },
    async search () {
      this.loading = true
      const {totalElements, content} = await searchStatistic({...this.searchForm, page: this.pageNo - 1, size: this.pageSize})
      this.rows = content
      this.totalData = totalElements > 0 ? totalElements : 0
      this.loading = false
    },
    exportData () {
      alert('exportData')
    },
    clearFilterSearch () {
      this.searchForm = {
        contentId: '',
        account: '',
        action: '',
        startTime: null,
        endTime: null
      }
    },
    disabledStartTime (date) {
      if (this.searchForm.endDate) {
        return date > this.searchForm.endDate
      }
    },
    disabledEndTime (date) {
      return date < this.searchForm.startDate
    }
  },
  watch: {
    pageNo: {
      immediate: false,
      handler (newVal, oldVal) {
        this.search()
      }
    }
  }
}
</script>

<style scoped>
  @import "../../assets/css/filter_customs.css";
  @import "../../assets/css/table_customs.css";

  td {
    white-space: pre;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/ActivityManager.vue